import SchedulePrintMenu from "@/pages/human-resources/time-management/components/print-menu/SchedulePrintMenu";
import useDailySchedulePrintMenuController from "@/pages/human-resources/time-management/schedules/site-schedule/day-view/print-menu/useDailySchedulePrintMenuController";
import type { Size } from "@/shared/components/generic/UiEnums.ts";
import type { ReactNode } from "react";

interface Properties {
  size: Size;
}

export default function DailySchedulePrintMenu(props: Properties): ReactNode {
  const controller = useDailySchedulePrintMenuController();
  return (
    <SchedulePrintMenu
      buttonSize={props.size}
      menuItems={controller.menuItems}
      onItemClicked={controller.runAction}
    />
  );
}
